import React, { useState } from 'react';
import { Building2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import logosrc from '@/assets/logo.webp';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  className?: string;
  variant?: 'light' | 'dark';
  linkTo?: string;
}

const Logo: React.FC<LogoProps> = ({
  size = 'md',
  showText = true,
  className = '',
  variant = 'light',
  linkTo = '/'
}) => {
  const [logoError, setLogoError] = useState(false);
  const [logoLoaded, setLogoLoaded] = useState(false);

  const sizes = {
    sm: { icon: 'h-10 w-10', text: 'text-lg', container: 'h-6 w-6' },
    md: { icon: 'h-14 w-14', text: 'text-xl', container: 'h-8 w-8' },
    lg: { icon: 'h-24 w-24', text: 'text-2xl', container: 'h-18 w-18' },
    xl: { icon: 'h-34 w-34', text: 'text-3xl', container: 'h-28 w-28' }
  };

  const { icon, text, container } = sizes[size];
  const textColor = variant === 'dark' ? 'text-white' : 'text-gray-900';

  const handleError = () => {
    setLogoError(true);
  };

  const handleLoad = () => {
    setLogoLoaded(true);
  };


  const LogoContent = () => (
    <div className={`flex items-center space-x-2 ${className}`}>
      {/* Container du logo */}
      <div className={`relative ${container}`}>
        {!logoError ? (
          <>
            <img
              src={logosrc}
              alt="EXELIUS Logo"
              className={`h-full w-auto object-contain transition-opacity duration-300 ${
                logoLoaded ? 'opacity-100' : 'opacity-0'
              }`}
              onError={handleError}
              onLoad={handleLoad}
              loading="eager"
              decoding="async"
            />
            {!logoLoaded && !logoError && (
              <div className="absolute inset-0 animate-pulse bg-gray-200 rounded"></div>
            )}
          </>
        ) : (
          <div className={`flex items-center justify-center h-full w-full rounded-lg ${
            variant === 'dark' ? 'bg-white/20' : 'bg-blue-600'
          }`}>
            <Building2 className={`${icon} ${
              variant === 'dark' ? 'text-white' : 'text-white'
            }`} />
          </div>
        )}
      </div>
      
      {/* Texte du logo */}
      {showText && (
        <span className={`font-bold ${textColor} ${text} tracking-tight`}>
          EXELIUS
        </span>
      )}
    </div>
  );

  return linkTo ? (
    <Link to={linkTo} className="inline-block">
      <LogoContent />
    </Link>
  ) : (
    <LogoContent />
  );
};

export default Logo;